import BigNumber from 'bignumber.js'

export function normalizePercent(value: number) {
    return isNaN(value) ? value : new BigNumber(value).decimalPlaces(2).toNumber()
}
